<template>
    <div class="top-nav">
        <div class="main">
            <div class="logo-con">
                <img :src="logoUrl" style="width:100%">
            </div>

            <div
            class="root-menu"
            >
                <menu-bar
                    ref="root"
                    :data="menuList"
                    @select="menuSelHandler"
                ></menu-bar>
            </div>
            
            <div class="operation">
                 <el-dropdown v-if="ishbdx==='1'">
                    <el-tooltip effect="dark" content="客服" placement="bottom" :disabled="!hideBtnText">
                         <el-button type="text" style="margin-right:10px;">
                            <i class="el-icon-chat-dot-round"></i> 
                            {{hideBtnText ? '' : '客服'}}
                        </el-button>
                    </el-tooltip>
                    <el-dropdown-menu slot="dropdown" class="xxx">
                        <el-dropdown-item style="color:#409EFF;font-weight:800;font-size:13px">系统问题请联系：</el-dropdown-item>
                        <el-dropdown-item >手机号：15803215511</el-dropdown-item>
                        <el-dropdown-item>固定电话：4007809998</el-dropdown-item>
                        <el-dropdown-item style="color:#409EFF;font-weight:800;font-size:13px">项目问题请联系：</el-dropdown-item>
                        <el-dropdown-item>手机号：18032103496</el-dropdown-item>
                        <el-dropdown-item>固定电话：0311-85818063</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-tooltip effect="dark" content="切换到旧版本" placement="bottom" :disabled="!hideBtnText" id="changesystem">
                    <el-button type="text" @click="goto('/bidding/workbench/index')">
                        <i class="sysfont">&#xeb90;</i>
                        {{hideBtnText ? '' : '切换到旧版本'}}
                    </el-button>
                </el-tooltip>

                <el-tooltip effect="dark" content="项目提醒" placement="bottom" :disabled="!hideBtnText">
                    <el-button type="text" @click="drawer = true" style="height:54px;margin-top:-20px">
                        <el-badge :value="remindNum" class="item" :hidden="remindNum==0">
                            <i class="sysfont">&#xe61e;</i>
                        </el-badge>
                        {{hideBtnText ? '' : '项目提醒'}}
                    </el-button>
                </el-tooltip>
                <!--
                <el-tooltip effect="dark" content="公众号提醒" placement="bottom" :disabled="!hideBtnText" id="tip">
                    <popover-wechat-info>
                        <el-button type="text">
                            <i class="sysfont" style="font-size:18px">&#xe664;</i>
                            {{hideBtnText ? '' : '公众号提醒'}}
                        </el-button>
                        
                    </popover-wechat-info>
                </el-tooltip>
                -->
                <el-tooltip effect="dark" content="提交工单" placement="bottom" :disabled="!hideBtnText">
                    <el-button type="text" @click="menuSelHandler({text:'提交工单', url:'/manage/business/xgsq/list', type: 'hash'})">
                        <i class="sysfont">&#xe621;</i>
                        {{hideBtnText ? '' : '提交工单'}}
                    </el-button>
                </el-tooltip>

                <user-info
                    :show.sync="hideBtnText"
                ></user-info>
            </div>
        </div>

        <el-drawer
            title="项目提醒"
            :visible.sync="drawer"
            :direction="direction">
                <div class="remindCon">
                    <ul>
                        <li v-for="(item,index) in remindList" :key="index">
                            <p style="color:#409EFF">【{{item.notice_type}}】</p>
                            <p style="margin-top:10px;text-indent:2em">{{item.notice_name}}</p>
                        </li>
                    </ul>
                </div>
        </el-drawer>

    </div>
</template>

<script>
import UserInfo from '@views/layout/components/user-info';
import MenuBar from './components/menu-bar';
import PopoverWechatInfo from './components/popover-wechat-info/index';
import Driver from 'driver.js'
import 'driver.js/dist/driver.min.css'
export default {
    components: {
        UserInfo,
        MenuBar,
        PopoverWechatInfo,
    },
    data() {
        return {
            logoUrl: `${window._config.rely}/newnavlogo.png`,
            drawer:false,
            direction:'rtl',
            remindNum:0,
            remindList:[],

            hideBtnText: false,
            ishbdx:'',
        }
    },
    computed: {
        menuList() {
            return this.getGetters('user').menuList2;
        },
    },
    watch: {
        menuList(n){
            this._setDefaultTag();
            
        }
    },
    created() {
        this.ishbdx = getSession('ishbdx')
    },
    methods: {
        //新用户引导教程
        driverD () {
            const driver = new Driver({
                allowClose: false,
                doneBtnText: '开始体验', // 结束按钮的文字
                stageBackground: '#ffffff', // 突出显示元素的背景颜色
                nextBtnText: '继续', // 下一步按钮的文字
                prevBtnText: '上一步', // 上一步按钮的文字
                closeBtnText: '关闭', // 关闭按钮的文字
                onHighlightStarted: (Element) => { }, // 元素即将突出显示时调用
                onHighlighted: (Element) => {
                console.log(Element)
                }, // 元素完全突出显示时调用
                onDeselected: (Element) => { }, // 取消选择元素时调用
                onReset: (Element) => {
                    let steps = driver.getSteps();
                    if (steps[steps.length - 1] == Element) {
                        this.$post(`${this.getGetters('mngUrl')}/v2/system/statistics/leadAccess.json`, {
                           leadtype:'home'
                        }, data => {
                            var obj = getSession('user')
                            obj.lead.home = true
                            setSession('user', obj);
                        });
                    }
                }, // 当要清除叠加时调用
                onNext: (Element) => { }, // 在任何步骤中移动到下一步时调用
                onPrevious: (Element) => { }// 在任何步骤中移动到上一步时调用
            })
            const steps = [
                {
                    element: '.root-menu',//传递选择器即可突出显示单个元素
                    popover: {
                        title: ' ',
                        description: '导航菜单挪到上面了',
                        position: 'bottom-right' // 可选 `top`, `left`, `right`, `bottom`
                    }
                },
                {
                    element: '#changesystem',
                    popover: {
                        title: ' ',
                        description: '点击切换新旧版本！',
                        position: 'bottom-center'// 可选 `top`, `left`, `right`, `bottom`
                    }
                },
                {
                    element: '.wechat_tip',
                    popover: {
                        title: ' ',
                        description: '点击可通过微信公众号发送提醒！',
                        position: 'bottom-center'// 可选 `top`, `left`, `right`, `bottom`
                    }
                },
                {
                    element: '.frame-con',
                    popover: {
                        title: ' ',
                        description: '点击添加项目吧！',
                        position: 'top-center' // 可选 `top`, `left`, `right`, `bottom`
                    }
                },
            ]
            driver.defineSteps(steps)
            driver.start()
        },
        menuSelHandler(item) {
            var children = item.children,
                menuexplain = !!(children && children.length);
            
            if (menuexplain) {
                // 非叶子菜单
                return;
            }

            this.$emit('select', item);
        },
        setActive(id, pid) {
            this.$refs.root.setActive(id, pid);
        },
        _setDefaultTag() {
            var firstRoot = this.menuList[0],
                blackList = ['110000'];

            if (blackList.some(item => item === firstRoot.id)) {
                firstRoot = this.menuList[1];
            }

            if (firstRoot && firstRoot.children && firstRoot.children.length) {
                var firstLeaf = firstRoot.children[0];

                this.$emit('default', firstLeaf);

                return;
            }

            this.$emit('default', firstRoot);
            if(getSession('user')){
                if (!getSession('user').lead.home||JSON.stringify(getSession('user').lead)=="{}") {
                    this.driverD()
                } else {
                    // to do不需要引导，其他操作
                }
            }
        },
        // 项目提醒
        
    },
    mounted() {
        // console.log(document.querySelector('.frame-item').querySelector(''))
        var that = this;
        this._setDefaultTag();
        // 项目提醒
        that.$get(`${this.getGetters('mngUrl')}/v2/notice/dbTxList.json`, (data, res) => {
           that.remindNum = data.total;
           that.remindList = data.noticeMap;
        });
        
    },
};
</script>

<style lang="scss" scoped>
    .top-nav{ 
        .main{
            padding: 12px 24px; 
            box-shadow: 0px 2px 2px 0 rgba(0, 0, 0, 0.1);
            overflow: hidden;
            height: 32px;
            display: flex;

            .logo-con{ 
                width: 113px; 
            }

            .root-menu{
                height: 56px;
                margin-left: 72px;
                line-height: 56px;
                margin-top: -12px;
                flex: 1;
                overflow: hidden;

                /deep/ {
                    .menu-bar{
                        line-height: 54px;
                    }
                }
            }

            .operation{
                margin-top: 4px;

                .el-button--text{ 
                    color: #333333; 
                    margin-left: 20px;
                    padding: 0;
                }

                /deep/ {
                    .el-button{
                        overflow: visible;
                    }
                }
            }

            /deep/ {
                .user-info-dropdown {
                    margin-top: 0;
                    margin-left: 20px;

                    .user-info{ 
                        margin-top: 0;
                        padding: 0;
                    }
                }
            }
        }

        .sub-menu{
            line-height: 44px;
            box-shadow: 0px 2px 2px 0 rgba(0, 0, 0, 0.1);

            /deep/ {
                & > .ant-menu-item:hover, 
                & > .ant-menu-submenu:hover, 
                & > .ant-menu-item-active, 
                & > .ant-menu-submenu-active, 
                & > .ant-menu-item-open, 
                & > .ant-menu-submenu-open, 
                & > .ant-menu-item-selected, 
                & > .ant-menu-submenu-selected {
                    border-color: transparent;
                }
            }
        }
    }
    /deep/ .el-badge__content.is-fixed{ top: -5px}
    .remindCon{ padding: 0 25px; } 
    .remindCon li{ margin-bottom: 15px; }
   
</style>

<style lang="scss" >
    .home-page{
        width: 100%;
        height: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }
    [class*="driver-close-btn"] {
        visibility: hidden;
    }
    [class*='driver-prev-btn'] {
        visibility: hidden;
    }
    div#driver-popover-item .driver-popover-footer button {
        background-color: #1890ff;
        color: white;
        text-shadow: none; /* 取消原来的text阴影，不然会有文字重叠的感觉 */
        border: none; /* 取消原来它自己按钮设置的border */
        line-height: 1.8;
        border-radius: 4px;
    }

    div#driver-popover-item .driver-popover-footer button:hover {
        background-color: #50abff;
    }

    div#driver-popover-item .driver-popover-footer button:active {
        background-color: #1269ba;
    }
</style>